/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для блока допродажи в корзине
   */
  app.CartUpsaleView = app.View.extend({
    el: '.upsale-cart-block',
    events: {
      'click .js-button-close': 'hide',
      'click .js-button-reject': 'rejectUpsale',
      'mouseenter .js-preview': 'renderImagePreview',
      'click .cart-action-link-image': 'triggerUpsaleItemClick',
      'click .catalog__item-title': 'triggerUpsaleItemClick',
    },

    /**
     * @inheritDoc
     */
    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate('#cart-upsale-template');
      this.successTemplate = app.helpers.TemplateHelper.getTemplate('#cart-upsale-success-template');
      this.listenTo(this.model, 'sync', this.renderUpsaleItem);
    },

    /**
     * Устанавливаем текущие цены и знак валюты после смены валюты.
     */
    fetchWithCurrentCurrency: function () {
      this.model.set('currency', this.cart.currency.name);
      this.model.fetch();
    },

    /**
     * Рендер суммы для разметки
     */
    renderUpsaleItem: function () {
      var templateData = this.model.toJSON();
      templateData.priceArray = app.helpers.NumberHelper.numberWithoutZeroFraction(templateData.price);
      templateData.oldPriceArray = app.helpers.NumberHelper.numberWithoutZeroFraction(templateData.price_max);
      Backbone.trigger('upsale-item', 'show');
      this.render(templateData);
      this.initQtyView();
      this.initImagePreview();
    },

    /**
     * Инициализация превью фото
     */
    initImagePreview: function () {
      if (!app.isMobile) {
        this.childViews.imagePreviewView = new app.ImagePreviewView({el: this.$('.hint-preview'), model: this.model});
      }
    },

    /**
     * Рендер превью фото
     */
    renderImagePreview: function () {
      if (this.childViews.imagePreviewView) {
        this.childViews.imagePreviewView.render(true);
      }
    },

    /**
     * Инициализация кнопки добавления товара в корзину
     */
    initQtyView: function () {
      this.cartItem = new app.CartItem();
      this.childViews.qtyView = new app.ItemQtyView({
        el: this.el,
        item: this.model,
        model: this.cartItem,
        cart: this.cart,
        user: this.user,
        settlement: this.settlement,
      });
      this.childViews.qtyView.initDom();

      this.listenTo(this.cartItem, 'change', this.showMessageAndRefresh);
    },

    /**
     * Показать сообщение и обновить товар.
     */
    showMessageAndRefresh: function () {
      this.showSuccessMessage();
      this.startFetchTimeout();
    },

    /**
     * Скрытие блока допродажи
     */
    hide: function() {
      this.$el.addClass('not_display');
    },

    /**
     * Показ сообщения об успешном добавлении товара в корзину
     */
    showSuccessMessage: function() {
      Backbone.trigger('upsale-item', 'add', this.model.get('sid'));
      this.$el.html(this.successTemplate());
    },

    /**
     * Установка обновленной модели по истечении 0.5 секунды.
     */
    startFetchTimeout: function() {
      setTimeout(this.model.fetch.bind(this.model), 500);
    },

    /**
     * Закрытие блока допродажи и сохранение товара в список отмененных
     */
    rejectUpsale: function () {
      var isGuest = this.user && !this.user.get('id');
      this.hide();
      if (!isGuest) {
        this.rejectItem = new app.UpsaleItemRejection({
          item_id: this.model.get('id'),
        });
        this.rejectItem.save();
      }
    },

    /**
     * Отправка события клика на товаре для око
     */
    triggerUpsaleItemClick: function () {
      Backbone.trigger('upsale-item', 'click', this.model.get('sid'));
    }
  });
})(jQuery);

}.call(window));